export default __webpack_public_path__ + "static/media/create_goal.3538d6d2.png";